import Handsontable from 'handsontable';
import store from "@/store/store";

const Base: any = Handsontable.editors.AutocompleteEditor;


/**
 * Cache editor, Handsontable hangs on to created editors, so handing out a fresh class per column would pile up
 * registrations.
 */
const editors = new Map<string, any>();

/**
 * Autocomplete editor that marks options that are not part of the bro
 *
 * Uses the afterRender hook that is called on all autocomplete choice rows
 *
 * @param relation the relation to check for bro value
 */
export const flaggedAutocompleteEditor = (relation: string) => {
    const cached = editors.get(relation);

    if (cached) {
        return cached;
    }

    const editor = Base.prototype.extend();

    editor.prototype.open = function (...args: any[]) {
        Base.prototype.open.apply(this, args);

        const choicesList = this.htEditor.getInstance();
        const highlight = choicesList.getSettings().afterRenderer;

        choicesList.updateSettings({
            afterRenderer(
                td: HTMLTableCellElement,
                row: number,
                column: number,
                prop: string | number,
                value: any
            ) {
                // Set native highlight styles
                if (highlight) {
                    highlight.call(this, td, row, column, prop, value);
                }

                // Set text color, so we do not interfere with native highlight styles
                if (store.getters.valueNotInBro(relation, value)) {
                    td.style.color = '#e67e22';
                }
            },
        });
    };

    editors.set(relation, editor);

    return editor;
};
